import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button', 'container']

  connect() {
    this.frameLoad = this.handleFrameLoad.bind(this)

    document.addEventListener('turbo:before-fetch-request', this.frameLoad)
  }

  disconnect() {
    document.removeEventListener('turbo:before-fetch-request', this.frameLoad)
  }

  handleFrameLoad() {
    const modalContainingDropdown = this.findModal()

    if (modalContainingDropdown) {
      this.hide(null)
    }
  }

  toggle(event) {
    event?.preventDefault()
    event?.stopPropagation()

    if (this.isOpen()) {
      this.hide(null)
      return
    }

    this.show()
  }

  show() {
    this.hideOtherDropdownMenus()

    this.buttonTarget.setAttribute('aria-expanded', 'true')
    const modalContainingDropdown = this.findModal()

    this.containerTarget.style.display = 'initial'
    if (modalContainingDropdown) {
      let totalHeight = 0
      Array.from(this.containerTarget.children).forEach((child) => {
        totalHeight += child.offsetHeight
      })
      const currentHeight = parseInt(modalContainingDropdown.style.height, 10) || modalContainingDropdown.offsetHeight
      modalContainingDropdown.style.height = `${currentHeight + totalHeight}px`
    }
  }

  findModal() {
    const modals = document.getElementsByClassName('open-modal')
    let modalContainingDropdown = null

    for (const modal of modals) {
      if (modal.contains(this.containerTarget)) {
        modalContainingDropdown = modal
        break
      }
    }

    return modalContainingDropdown
  }

  hide(event) {
    if (this.isOwnTarget(event)) {
      return
    }

    this.forceHide(event)
  }

  forceHide(_event) {
    this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.containerTarget.style.display = 'none'
    this.resetModalHeight()
  }

  resetModalHeight() {
    const modalContainingDropdown = this.findModal()

    if (modalContainingDropdown) {
      modalContainingDropdown.style.height = 'initial'
    }
  }

  isOpen() {
    return this.buttonTarget.getAttribute('aria-expanded') === 'true'
  }

  isOwnTarget(event) {
    return event && (this.containerTarget.contains(event.target) || this.buttonTarget.contains(event.target))
  }

  hideOtherDropdownMenus() {
    document.querySelectorAll('[data-controller~="dropdown-menu"]').forEach((element) => {
      if (element === this.element) return

      const controller = this.application.getControllerForElementAndIdentifier(element, 'dropdown-menu')
      controller?.forceHide(null)
    })
  }
}
